import { number } from 'yup'
import { safify } from '../utils/safify'

export const sourceVisualElementId = number().default(undefined).meta({ label: 'Choose Template' }).transform(safify)
